/**
 * clinicalMapping.js - Shared clinical terminology and formatting utils
 */

export const COMPETENCY_NAMES = {
    "agenda_setting": "Agenda Setting",
    "pacing": "Pacing & Time Use",
    "feedback": "Feedback",
    "collaboration": "Collaboration",
    "interpersonal_effectiveness": "Interpersonal Effectiveness",
    "eliciting_emotion": "Eliciting Emotion",
    "eliciting_cognitions": "Eliciting Cognitions",
    "guided_discovery": "Guided Discovery",
    "conceptual_integration": "Conceptual Integration",
    "behavioral_interventions": "Behavioral Interventions",
    "change_methods": "Change Methods",
    "homework": "Homework Setting",
    "active_listening": "Active Listening",
    // NIMHANS Mapping
    "nh_session_structure_rapport": "Session Structure & Rapport",
    "nh_assessment_exploration": "Assessment & Exploration",
    "nh_therapeutic_presence": "Therapeutic Presence",
    "nh_case_formulation": "Case Formulation",
    "nh_intervention_relevance": "Intervention Relevance",
    "nh_goal_setting_action_planning": "Goal & Action Planning",
    "nh_time_management": "Time Management",
    "nh_termination_continuity": "Termination & Continuity",
    "nh_ethical_professionalism": "Ethics & Professionalism",
    "nh_risk_safety": "Risk & Safety Screening"
};

/**
 * Maps a technical competency key or a reason string containing a key 
 * to its human-readable equivalent.
 * 
 * @param {string} text - The technical key or sentence containing keys
 * @returns {string} - Human-readable text
 */
export const formatClinicalText = (text) => {
    if (!text) return "";
    let final = text;
    
    // Sort keys by length descending to avoid partial matches (e.g., 'nh_risk' matching before 'nh_risk_safety')
    const keys = Object.keys(COMPETENCY_NAMES).sort((a, b) => b.length - a.length);

    keys.forEach(k => {
        const pattern = new RegExp(`\\b${k}\\b`, 'gi');
        final = final.replace(pattern, () => COMPETENCY_NAMES[k]);
    });

    // Cleanup: Replace remaining underscores with spaces and capitalize words if no mapping found
    return final.replace(/_/g, ' ');
};
